import { render, staticRenderFns } from "./sancionOperadorFrontera.vue?vue&type=template&id=ecbdf2e8&"
import script from "./sancionOperadorFrontera.vue?vue&type=script&lang=js&"
export * from "./sancionOperadorFrontera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports